<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/v1XfRj/tc-custom/9783988269409.jpg?1704425605261" alt="This image is the cover for the book Miscellanies, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Miscellanies, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Miscellanies is a collection of essays and writings by Ralph Waldo Emerson, the renowned American essayist, lecturer, and philosopher. Emerson was a central figure in the transcendentalist movement of the 19th century, and his essays and lectures are celebrated for their philosophical insights and literary style. The contents of "Miscellanies" encompass a wide range of Emerson's thoughts and ideas on various subjects, including nature, self-reliance, individualism, society, art, and spirituality. The collection is reflective of Emerson's belief in the importance of self-discovery, self-expression, and the transcendental connection between individuals and the universe."Miscellanies" represents Emerson's philosophical and literary contributions to the American transcendentalist movement, which celebrated individualism, nature, and the search for truth and meaning in a rapidly changing world. The collection provides readers with an opportunity to engage with Emerson's profound insights and eloquent prose on a variety of topics.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ralph Waldo Emerson
      </h2>
      
      <p class="authorDescription body article">Ralph Waldo Emerson (1803-1882) was an American essayist, poet, and philosopher who played a significant role in the transcendentalist movement of the 19th century. He is widely regarded as one of the most influential figures in American literature and thought. His work focused on individualism, self-reliance, and the exploration of the relationship between humanity and nature. Emerson's writings continue to be widely read and studied, and his philosophy of self-reliance and the interconnectedness of all life remains influential in American literature and thought.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2668c48c